module.exports = __webpack_public_path__ + "img/Vojtěch Šimetka.2ac26945.jpg";